<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Badges
        <small>List of badges</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">Badges</li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Filter Badges</h3>
          <div class="box-tools pull-right">
            <button type="button"
              class="btn btn-box-tool"
              data-widget="collapse">
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="box-body" style="overflow: initial">
            <div class="left-form">
              <div class="form-group">
                <label for="name">
                  Name
                </label>

                <input type="text"
                  class="form-control"
                  id="name"
                  placeholder="Search by name here"
                  v-model="params.name"
                  @keyup="onInput">
              </div>

              <div class="form-group">
                <label for="status" >
                  Status
                </label>
                <div>
                  <select
                    id="status"
                    class="form-control"
                    placeholder="Select status"
                    v-model="params.status"
                    value="null"
                    >
                    <option v-for="(status, index) in statuses" :key="index" :value="status.value">{{ status.title }}</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label for="type">
                  Badges Type
                </label>
                <div>
                  <select
                    id="type"
                    class="form-control"
                    placeholder="Select type"
                    v-model="params.type"
                    value="null"
                    >
                    <option v-for="(type, index) in types" :key="index" :value="type.value">{{ type.title }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="right-form">
              <div class="form-group">
                <label for="start_date">
                  Start Date
                </label>

                <div>
                  <datepicker
                    id="start_date"
                    wrapper-class="custom-vdp"
                    input-class="form-control"
                    :clear-button="true"
                    v-model="start_date">
                  </datepicker>
                </div>
              </div>

              <div class="form-group">
                <label for="end_date">
                  End Date
                </label>

                <div>
                  <datepicker
                    id="end_date"
                    wrapper-class="custom-vdp"
                    input-class="form-control"
                    :clear-button="true"
                    v-model="end_date">
                  </datepicker>
                </div>
              </div>

            </div>
            <div>
              <button class="btn btn-success pull-right position-bottom" @click="pushState()">
                Search
              </button>
            </div>

        </div>
      </div>

      <div class="box">
        <div class="box-header">
          <a class="btn btn-success pull-right"
            @click.prevent="add">
            Add New Badges
          </a>
        </div>

        <div class="box-body">
          <table id="table" class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Badges Type</th>
                <th class="text-center">Image</th>
                <th>Status</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Action(s)</th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="isLoading">
                <td class="text-center" colspan="7">
                  <strong>Loading...</strong>
                </td>
              </tr>
              <tr v-if="!isLoading && error" key="empty">
                <td class="text-center" colspan="7">
                  <strong>Data failed to load</strong>
                </td>
              </tr>
              <tr v-if="!isLoading && !badges">
                <td class="text-center" colspan="7">
                  <strong>Result Not Found</strong>
                </td>
              </tr>
              <tr v-for="badge in badges" :key="badge.id">
                <td>{{ badge.name }}</td>
                <td>{{ badgeType(badge.type) }}</td>
                <td class="text-center">
                  <img
                    v-if="badge.image && badge.image != ''"
                    :src="parseImage(badge.image, '_thumb')"
                    style="width: 64px;" />
                </td>
                <td>{{ badge.status}}</td>
                <td>{{ badge.start_date }}</td>
                <td>{{ badge.end_date }}</td>
                <td>
                  <a class="btn btn-primary btn-xs"
                    @click.prevent="edit(badge.id)">
                    Edit
                  </a>
                  <a class="btn btn-danger btn-xs"
                    @click.prevent="remove(badge)">
                    Delete
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="box-footer">
          <Pagination
            :pagination="pagination"
            @goto-page="changePage" />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import debounce from 'lodash/debounce';
import Common from '@/mixins/Common';
import Pagination from '@/components/modules/common/Pagination';

export default {
  name: 'BadgesIndex',
  mixins: [Common],
  components: {
    Pagination,
    Datepicker,
  },
  data() {
    return {
      params: {
        name: null,
        page: null,
        type: null,
        status: null,
      },
      start_date: null,
      end_date: null,
      badges: [],
      isLoading: false,
      error: null,
      pagination: {},
      statuses: [
        { 
          title: 'All Badges Status',
          value: null, 
        },
        {
          title: 'Active',
          value: 'active',
        },
        {
          title: 'Inactive',
          value: 'inactive',
        },
      ],
      types: [
        { 
          title: 'All Badges Type',
          value: null, 
        },
        { 
          title: 'Default Badges',
          value: 'default_badge', 
        },
        { 
          title: 'Top Hover Badges',
          value: 'top_badge', 
        },
        { 
          title: 'Bottom Hover Badges',
          value: 'bottom_badge', 
        },

      ],
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      await this.setQuery();
      await this.fetch();
      this.isInitial = false;
    },

    setQuery() {
      return new Promise((resolve) => {
        this.params.name = this.$route.query.name || null;
        this.params.page = this.$route.query.page || null;
        this.params.type = this.$route.query.type || null;
        resolve();
      });
    },

    fetch(page = null) {
      this.isLoading = true;
      if (page) this.params.page = page || null;

      this.axios.get('/badges', { params: { ...this.params, start_date: this.startDate, end_date: this.endDate } })
        .then((response) => {
          const { data, meta } = response.data;

          const isEmpty = (!data && 
                          (meta.pagination.current_page > 
                          meta.pagination.total_pages));
          this.badges = (!isEmpty) ? data : [];
          this.pagination = (!isEmpty) ? meta.pagination : {};
          this.setPushState();
        })
        .catch((error) => {
          console.log('Fetch error', error);

          if (error.response) {
            this.error = error.response.data.errors;
          }

          if (error) {
            this.$swal({
              title: 'Failed!',
              text: 'Failed to fetch Data', 
              type: 'warning',
              timer: 3000,
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    pushState() {
      this.fetch();
    },
    setPushState() {
      const title = `Badges page ${this.params.page}`;
      const paramUrl = '/badges';
      const parameters = this.generateQuery(this.params);
      const startParam = this.startDate ? `&start_date=${this.startDate}` : '';
      const endParam = this.endDate ? `&end_date=${this.endDate}` : '';
      window.history.pushState(title, null, `${paramUrl}${parameters}${startParam}${endParam}`);
    },

    generateQuery(params) {
      if (!params) return null;

      const query = Object.keys(params)
        .filter(key => (params[key]))
        .map(key => `${key}=${this.params[key]}`);

      return (query) ? `?${query.join('&')}` : null;
    },

    onInput: debounce(function debouncedInput() {
      this.params.page = null;
      this.fetch();
    }, 500),

    changePage(page) {
      this.fetch(page);
    },

    add() {
      this.$router.push({
        name: 'badges-create',
      });
    },

    edit(id) {
      this.$router.push({
        name: 'badges-edit',
        params: {
          id,
        },
      });
    },

    delete(badge) {
      this.axios.delete(`/badges/${badge.id}`)
        .then(() => {
          this.fetch();

          this.$swal({
            title: 'Deleted',
            text: `${badge.name} has been deleted.`,
            type: 'success',
            timer: 3000,
          });
        })
        .catch((error) => {
          if (error.response) {
            this.$swal({
              title: 'Failed',
              text: `Oppss! You can't delete "${badge.name}" because this category still used by the product`,
              type: 'error',
              timer: 8000,
            });
          }
        });
    },

    remove(badge) {
      this.$swal({
        title: 'Deleting Badge',
        text: `Are you sure you want to delete ${badge.name}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      })
      .then((result) => {
        if (result.value) {
          this.delete(badge);
        } else {
          this.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000,
          });
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          this.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000,
          });
        }
      });
    },
  },
  computed: {
    startDate() {
      if (this.start_date) {
        return this.parseTime(this.start_date, 'YYYY-MM-DD');
      }
      return null;
    },
    endDate() {
      if (this.end_date) {
        return this.parseTime(this.end_date, 'YYYY-MM-DD');
      }
      return null;
    },
    badgeType() {
      return (v) => {
        if (v === 'default_badge') {
          return 'Default Badges';
        }
        if (v === 'top_badge') {
          return 'Top Hover Badges';
        }
        if (v === 'bottom_badge') {
          return 'Bottom Hover Badges';
        }
        return null;
      };
    },
    disabledStartDate() {
      return {
        to: (this.start_date) ? moment(this.start_date).subtract(1, 'days').toDate() 
                                   : moment().subtract(1, 'days').toDate(),
      };
    },
    disabledEndDate() {
      return {
        to: (this.start_date) ? moment(this.start_date).toDate() : moment().toDate(),
      };
    },
  },
};
</script>
<style lang="scss" scoped>
  .left-form {
    width: 40%;
    float: left;
    margin-right: 50px;
  }
  .right-form {
    width: 40%;
    float: left;
  }
  .position-bottom {
    position: absolute;
    bottom: 25px;
    right: 10px;
    width: 100px;
  }
</style>




// WEBPACK FOOTER //
// src/components/modules/badges/Index.vue